import { useTranslation } from 'react-i18next';

export function Disclaimer() {
  const { t } = useTranslation();
  return (
    <div className="relative clip-corners-sm border border-valo-red/30 bg-valo-red/5 p-3 text-xs leading-relaxed">
      <div className="flex items-start gap-2">
        <svg
          viewBox="0 0 24 24"
          className="h-4 w-4 flex-none text-valo-red mt-0.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <div>
          <div className="font-display uppercase tracking-widest text-valo-red text-xs">
            {t('disclaimer.title')}
          </div>
          <p className="mt-1 text-valo-muted">{t('disclaimer.text')}</p>
        </div>
      </div>
    </div>
  );
}

export function PageHeader({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <header className="mb-5">
      <h1 className="font-display text-3xl uppercase text-valo-white leading-none">
        <span className="relative inline-block">
          {title}
          <span className="absolute -left-3 top-1 h-[70%] w-1 bg-valo-red" />
        </span>
      </h1>
      {subtitle && <p className="mt-1.5 text-sm text-valo-muted">{subtitle}</p>}
    </header>
  );
}

export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`skeleton clip-corners-sm ${className}`} />;
}

export function Button({
  children,
  variant = 'primary',
  className = '',
  ...rest
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'primary' | 'ghost' | 'danger' }) {
  const base =
    'clip-corners-sm font-display uppercase tracking-widest text-sm px-4 py-2.5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
  const variants: Record<string, string> = {
    primary: 'bg-valo-red text-valo-white hover:bg-valo-red-dark active:bg-valo-red-dark',
    ghost: 'bg-transparent border border-valo-navy-border text-valo-white hover:bg-valo-navy-soft',
    danger: 'bg-transparent border border-valo-red/50 text-valo-red hover:bg-valo-red/10',
  };
  return (
    <button className={`${base} ${variants[variant]} ${className}`} {...rest}>
      {children}
    </button>
  );
}
